// extracted by mini-css-extract-plugin
export default {"fsEmptyState":"empty-state-module--fs-empty-state--45d6a"};